import { Button } from 'components-antd';

import styles from './styles.module.scss';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import { useMemo } from 'react';
import { link } from 'settings/navigation/link';
import { FormsTableStatus } from 'app-constants';

export const ViewFormButton = (props) => {
  const { formDetails, handleViewForm, disableSections, selectedFormStatus } = props;

  const history = useHistory();

  const isWaitingOnYouForm = selectedFormStatus === FormsTableStatus.WaitingOnYou;

  const nonVoidDocuments = useMemo(
    () => formDetails?.formDocuments?.filter(({ isVoid }) => !isVoid),
    [formDetails],
  );

  const hasMultipleDocuments = nonVoidDocuments && nonVoidDocuments.length;
  const showLeftPanel = true;

  const onViewForm = () => {
    if (formDetails && formDetails.formDocument?.url) {
      if (hasMultipleDocuments) {
        const [formProcessPublicId] = formDetails.formDocument.url.split('/');
        const allDocuments = nonVoidDocuments.map((item) => ({
          ...item,
          Order: item.order,
          PublicId: item.url.split('/')[1],
        }));

        history.push({
          pathname: link.toWorkshopDynamicFormBundle({
            formProcessPublicId,
          }),

          state: {
            formBundle: true,
            allDocuments,
            bundleName: formDetails?.formName,
            redirectionLink: location.pathname,
          },
        });
      } else {
        handleViewForm(formDetails?.formDocument?.url, formDetails?.formDocument?.type);
      }
    }
  };

  return (
    <div className={styles.buttonWrapper}>
      <Button
        variant="secondary"
        className={classNames(showLeftPanel ? styles.viewFormBtn : styles.viewFormFixBtn, {
          [styles.disabledSection]: disableSections,
        })}
        onClick={onViewForm}
        disabled={disableSections}
      >
        {isWaitingOnYouForm ? 'Sign' : 'View'}
      </Button>
    </div>
  );
};
